
import React from 'react'
// import urlConstant from '../../constants/urlConstant';
import CommonService from '../../services/commonService';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.CommonService = new CommonService();
    }
    
  componentDidCatch(error, info) {
    console.log(info)
      this.CommonService.AddErrorLog(error.message,error.stack)
  }
  
    render() {
      const {children} = this.props
      return children;
    }
  }

  export default ErrorBoundary;